import PaymentTypes from '@/models/PaymentTypes';
import CardProcessor from '@/services/payment/processors/CardProcessor';
import BoletoProcessor from '@/services/payment/processors/BoletoProcessor';
import PixProcessor from '@/services/payment/processors/PixProcessor';
import QrCodePayProcessor from '@/services/payment/processors/QrCodePayProcessor';
import AleloVoucherProcessor from '@/services/payment/processors/AleloVoucherProcessor';
import ClickToPayProcessor from '@/services/payment/processors/ClickToPayProcessor';
import MultibenefitsProcessor from '@/services/payment/processors/MultibenefitsProcessor';
import GooglePayProcessor from '@/services/payment/processors/GooglePayProcessor';
import ApplePayProcessor from '@/services/payment/processors/ApplePayProcessor';
import PixOpenFinanceProcessor from '@/services/payment/processors/PixOpenFinanceProcessor';
import ProcessorWithMpiAuthentication from '@/services/payment/processors/ProcessorWithMpiAuthentication';
import DataOnFileProcessor from '@/services/payment/processors/DataOnFileProcessor';
import store from '@/store';
import Swal from 'sweetalert2';

export default {
    multiLanguage: null,
    /**
     * Retorna uma instância de um processador de pagamento
     * @param {Number} paymentType Tipo de pagamento
     */
    GetPaymentProcessor(paymentType) {
        let shouldUseMpi = store.getters['mpi/shouldAuthenticate'] ||
                           store.getters['mpi/shouldUseDataOnly'];
        switch (paymentType) {
        case PaymentTypes.CREDIT_CARD:
            return shouldUseMpi
                ? new ProcessorWithMpiAuthentication(new CardProcessor(this.multiLanguage), this.multiLanguage)
                : new CardProcessor(this.multiLanguage);

        case PaymentTypes.DEBIT_CARD:
            return new ProcessorWithMpiAuthentication(new CardProcessor(this.multiLanguage), this.multiLanguage);

        case PaymentTypes.BOLETO:
            return new BoletoProcessor(this.multiLanguage);

        case PaymentTypes.PIX:
            return new PixProcessor(this.multiLanguage);

        case PaymentTypes.QRCODE:
        case PaymentTypes.QRCODE_DEBIT:
            return new QrCodePayProcessor(this.multiLanguage);

        case PaymentTypes.VOUCHER:
            return new AleloVoucherProcessor(this.multiLanguage);

        case PaymentTypes.CLICK_TO_PAY:
            return new ClickToPayProcessor(this.multiLanguage);
        
        case PaymentTypes.MULTIBENEFITS:
            return new MultibenefitsProcessor(this.multiLanguage);

        case PaymentTypes.GOOGLE_PAY:
            return new GooglePayProcessor(this.multiLanguage);

        case PaymentTypes.APPLE_PAY:
            return new ApplePayProcessor(this.multiLanguage);
            
        case PaymentTypes.PIX_OPEN_FINANCE:
            return new PixOpenFinanceProcessor(this.multiLanguage);

        case PaymentTypes.DOF:
            return new DataOnFileProcessor(this.multiLanguage);

        default:
            this.ShowUnexpectedError();
            break;
        }
    },

    /**
     * Exibe mensagem de erro
     */
    ShowUnexpectedError() {        
        Swal.fire({
            type: 'error',
            title: 'Oppsss!',
            text: this.multiLanguage.get('paymentProviderPurchaseError')
        });
    }
};